(function () {
    'use strict';

    angular
        .module('corporateRoleEditModule', [
            'services.authenticatedUser',
            'aricModule',
            'governanceProcessModule',
            'services.attachments',
            'services.historyCtxt',
            'committeeModule'
        ]);
})();
